var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot"},[_c('div',{staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"blue"}),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v("最新热点")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/xinwen.html"}},[_c('p',{staticClass:"more"},[_vm._v("更多>")])])],1),_vm._v(" "),_c('Nav')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96dca34e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hot.vue
// module id = null
// module chunks = 